/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createTaskItemFromDiscriminatorValue, serializeReorderTasksRequest, serializeTaskItem, type ErrorResponse, type InternalErrorResponse, type ReorderTasksRequest, type TaskItem } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/tasks/reorder
 */
export interface ReorderRequestBuilder extends BaseRequestBuilder<ReorderRequestBuilder> {
    /**
     * Arranges the tasks of one status column on the tasks board. Send the column's tasks top to bottom in their new order: each takes its position in the list as its sortOrder, starting at 0, and nothing else about them changes. Tasks left out keep whatever position they had; a task that has never been arranged has no sortOrder and sits below the arranged ones in due-date order. The position is shared by everyone in the organization, and changing a task's status clears it, so a moved task lands at its due-date slot in its new column. Every task must exist, be visible to the caller, appear once and share one status; otherwise the whole request is rejected and nothing changes. A sales rep may reorder only tasks they can see.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TaskItem[]>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: ReorderTasksRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<TaskItem[] | undefined>;
    /**
     * Arranges the tasks of one status column on the tasks board. Send the column's tasks top to bottom in their new order: each takes its position in the list as its sortOrder, starting at 0, and nothing else about them changes. Tasks left out keep whatever position they had; a task that has never been arranged has no sortOrder and sits below the arranged ones in due-date order. The position is shared by everyone in the organization, and changing a task's status clears it, so a moved task lands at its due-date slot in its new column. Every task must exist, be visible to the caller, appear once and share one status; otherwise the whole request is rejected and nothing changes. A sales rep may reorder only tasks they can see.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: ReorderTasksRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReorderRequestBuilderUriTemplate = "{+baseurl}/api/tasks/reorder";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReorderRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ReorderRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createTaskItemFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReorderTasksRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
